export default {
  regular: {
    minHeight: '38px !important',
  }
}